import { useState, useEffect } from 'react';
import ApiClient from '../../../API/api';

// La sección "Nuevos" del menú solo se pinta si hay artículos en la ventana de 2 meses
// (mismo patrón que useHasCombinable con "Ofertas combinables").
export const useHasNewProducts = () => {
    const [hasNew, setHasNew] = useState(false);

    useEffect(() => {
        const fetch = async () => {
            try {
                const result = await ApiClient.performRequest('products/has-new');
                setHasNew(result === true);
            } catch {
                setHasNew(false);
            }
        };

        fetch();
    }, []);

    return hasNew;
};
